<template>
  <div class="box">
    <!-- PC 端展示第一张图 -->
    <img class="box-img box-img-pc" src="./assets/bag1.png" alt="" />
    <!-- 手机端展示第二张图 -->
    <img class="box-img box-img-mobile" src="./assets/bag2.png" alt="" />
    <!-- 页面底部备案号及联系方式 -->
    <div class="page-footer">
      <div class="footer-company">厘好车(北京)科技有限公司</div>
      <div class="footer-contact">
        <span>京公网安备11011502039590号</span>
        <!-- <span class="footer-dot">|</span> -->
        <!-- <span>18596408888@163.com</span> -->
      </div>
      <div class="footer-icp">京ICP备2026009223号</div>
    </div>
    <!-- 接口返回的下载二维码，固定展示 -->
    <div v-if="downloadQrcodes.length" class="qrcode-panel">
      <div v-for="(item, index) in downloadQrcodes" :key="index" class="qrcode-item">
        <div class="qrcode-thumb">
          <img :src="item.image" :alt="item.name" class="qrcode-img" />
        </div>
        <div class="qrcode-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { pcContent } from '../request/api'

export default {
  data() {
    return {
      downloadQrcodes: [],
    }
  },
  computed: {
    currentProducts() {
      return this.products;
    }
  },
  created() {
    this.loadPcContentQrcodes()
  },
  methods: {
    async loadPcContentQrcodes() {
      try {
        const res = await pcContent()
        if (res && res.code === 1 && res.data && Array.isArray(res.data.download_qrcode)) {
          this.downloadQrcodes = res.data.download_qrcode.slice(0, 3)
        }
      } catch (e) {
        console.error('pcContent 请求失败', e)
      }
    },
  }
}
</script>
<style scoped>
.box {
  width: 100%;
  background-image: white;
  position: relative;
  border: 1px solid white;
}

.box-img {
  width: 100%;
  height: 100%;
  display: block;
}

/* PC 端：显示第一张图，隐藏第二张图 */
.box-img-pc {
  display: block;
}

.box-img-mobile {
  display: none;
}

/* 手机端：隐藏第一张图，显示第二张图 */
@media (max-width: 768px) {
  .box-img-pc {
    display: none;
  }

  .box-img-mobile {
    display: block;margin-bottom: 80px;
  }
}

/* 页面底部备案号及联系方式 */
.page-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 16px 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.7);
  background: rgba(255, 255, 255, 0.6);
  line-height: 1.8;
}

.footer-company {
  font-weight: 500;
  margin-bottom: 4px;
}

.footer-contact {
  margin-bottom: 4px;
}

.footer-dot {
  margin: 0 8px;
  opacity: 0.6;
}

.footer-icp {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.55);
}

/* 下载二维码：右下角固定展示，避免遮挡底部备案区 */
.qrcode-panel {
  position: fixed;
  right: 16px;
  bottom: 100px;
  z-index: 10;
  display: flex;
  gap: 16px;
  align-items: flex-end;
}

.qrcode-item {
  text-align: center;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.qrcode-thumb {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.qrcode-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.qrcode-name {
  margin-top: 8px;
  font-size: 12px;
  color: #333;
  width: 104px;
  line-height: 1.3;
}

@media (max-width: 768px) {
  .qrcode-panel {
    right: 6px;
    bottom: 80px;
    gap: 6px;
  }

  .qrcode-item {
    padding: 5px 6px;
    border-radius: 6px;
    width: 80px;
    box-sizing: border-box;
  }

  .qrcode-thumb {
    width: 44px;
    height: 44px;
    margin: 0 auto;
  }

  .qrcode-name {
    margin-top: 4px;
    font-size: 10px;
   width: 100%;
    line-height: 1.25;
  }
}

.top {
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 96%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_left {
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
  height: 60px;
  margin-right: 16px;
}

.font {
  width: 124px;
  height: 34px;
}

.top_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.top_right_item {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #555555;
  margin-right: 76px;
}

.search_box {
  display: flex;
}

.select_in {
  font-weight: 600;
  font-size: 20px;
  color: #000504;
}

.search {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.swiper {
  width: 100%;
  height: 900px;
  position: relative;
  overflow: hidden;
}

.swiper_container {
  width: 100%;
  height: 100%;
  position: relative;
}

.swiper_slide {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.swiper_slide.active {
  opacity: 1;
}

.slide_background {
  width: 100%;
  height: 100%;
  position: relative;
}

.slide_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.slide_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.6) 100%);
}

.slide_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  max-width: 800px;
  padding: 0 20px;
  z-index: 10;
}

.slide_title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  line-height: 1.2;
}

.slide_subtitle {
  font-size: 24px;
  margin-bottom: 30px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  line-height: 1.4;
}

.slide_description {
  font-size: 18px;
  line-height: 1.8;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  opacity: 0.9;
}

.swiper_pagination {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 20;
}

.pagination_dot {
  width: 40px;
  height: 6px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination_dot:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: scale(1.05);
}

.pagination_dot.active {
  background: #fff;
  border-color: #fff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
}

.bg_img {
  width: 100%;
  height: 700px;
}

.about {
  padding: 80px 0;
  background: #fff;
}

.about_top {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  display: flex;
  gap: 60px;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 80px;
}

.about_left {
  flex: 1;
}

.about_building {
  width: 642px;
  height: 380px;
  object-fit: cover;
  border-radius: 8px;
}

.about_right {
  flex: 1;
  padding: 20px 0;
}

.about_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  margin-bottom: 12px;
}

.about_subtitle {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
}

.about_line {
  width: 711px;
  height: 0px;
  border: 4px solid #3D6451;
  opacity: 0.4;
  margin: 30px 0px;
  border-radius: 20px;
}

.about_content {
  margin-bottom: 32px;
}

.about_content p {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 16px;
}

.about_more1 {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 114px;
  height: 32px;
}

.about_more {
  position: absolute;
  right: 50%;
  transform: translate(50%, 0);
  bottom: 20px;
  z-index: 999;
  width: 114px;
  height: 32px;
}

.arrow {
  width: 16px;
  height: 16px;
}

.about_bottom {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.about_bottom_title {
  text-align: center;
  margin-bottom: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.business_cards {
  display: flex;
  overflow: auto;
  gap: 24px;
}

.business_card {
  position: relative;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 249px;
  height: 475px;
  border-radius: 20px;
}

.business_card:hover {
  width: 364px;
  transform: translateY(-8px);
}

.card_image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: contain;
}

.business_card_content {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 999;
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.card_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
}

.card_text {
  box-sizing: border-box;
  padding: 12px;
  text-align: left;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.about_more {
  width: 114px;
  height: 32px;
}

.card_more_btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 16px;
  border: 2px dashed #333;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.card_more_btn:hover {
  background: #f5f5f5;
}

.card_more_btn span {
  font-size: 14px;
  color: #333;
}

.people {
  display: flex;
  align-items: end;
  flex-direction: column;
  padding: 80px 0;
  background: #f5f5f5;
}

.people_container {
  width: 1200px;
  margin: 0 auto 20px;
  display: flex;
  gap: 60px;
  align-items: flex-start;
  padding: 0 20px;
}

.expert_photo_frame {
  width: 368px;
  height: 460px;
  border-radius: 8px;
}

.expert_photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.people_right {
  flex: 1;
}

.expert_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
  margin-bottom: 60px;
}

.expert_name {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  margin-bottom: 20px;
}

.expert_intro {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 24px;
}

.expert_separator {
  width: 100%;
  height: 1px;
  background: #ddd;
  margin: 24px 0;
}

.expert_details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail_section {
  display: flex;
  border-radius: 6px;
  margin-bottom: 10px;
}

.detail_title {
  flex-shrink: 0;
  width: 80px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-right: 22px;
}

.detail_content {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
  color: #3A3A3A;
}

.goods {
  padding: 80px 0;
  background: #fff;
}

.goods_container {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.goods_title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #000;
  margin-bottom: 40px;
}

.category_tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 60px;
}

.category_tab {
  font-size: 18px;
  color: #333;
  cursor: pointer;
  padding: 8px 0;
  transition: all 0.3s ease;
  position: relative;
}

.category_tab_active {
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
  position: relative;
  color: #222222;
}

.category_tab_active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #000;

  width: 72px;
  height: 4px;
  background: #222222;
  border-radius: 999px 999px 999px 999px;
}

.products_section {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
}

.left_img {
  width: 44px;
  height: 44px;
}

.goods_pages {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 480px;
  margin: 60px auto;
}

.nav_arrow {
  width: 40px;
  height: 40px;
  border: 2px dashed #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.nav_arrow:hover {
  background: #f5f5f5;
  border-color: #999;
}

.nav_arrow span {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.products_container {
  flex: 1;
  display: flex;
  gap: 24px;
  overflow: hidden;
}

.product_card {
  padding: 4px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.product_card:hover {
  box-shadow: 0 2px 8px #3D6451;

  border: #3D6451 1px solid;
  color: #3D6451;
}

.product_card_selected {
  flex: 1;
  background: #fff;
  border: 2px dashed #333;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 250px;
}

.product_image_container {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.product_image {
  border-radius: 8px;
  width: 100%;
  height: 300px;
  object-fit: cover;
}

.product_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product_type {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.product_tags {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product_tag {
  background: #4CAF50;
  color: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  align-self: flex-start;
}

.product_info {
  padding: 16px;
}

.product_name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-top: 16px;
  margin-bottom: 8px;
}

.product_name:hover {
  color: #3D6451;
}

.product_des {
  width: 288px;
  height: 38px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;

  overflow: hidden;
  /* 隐藏溢出 */
  word-break: break-all;
  /* break-all(允许在单词内换行。) */
  text-overflow: ellipsis;
  /* 超出部分省略号 */
  display: -webkit-box;
  /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical;
  /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2;
  /** 显示的行数 **/
}

.product_des:hover {
  color: #3D6451;
}

.news {
  padding: 80px 0;
  background: #f5f5f5;
}

.news_container {
  margin: 0px auto;
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.news_title {
  text-align: center;
  margin-bottom: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.news_cards {
  width: 100%;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: start;
}

.news_card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 440px;
  height: 420px;
}

.news_card:hover {
  transform: translateY(-8px);
}

.news_image_container {
  width: 440px;
  height: 262px;
}

.news_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news_content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news_article_title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.news_article_description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.news_article_date {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
}

.news_look {
  display: flex;
  align-items: center;
}

.news_look_icon {
  width: 22px;
  height: 22px;
}

.news_view_btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px dashed #333;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.news_view_btn:hover {
  background: #f5f5f5;
}

.news_view_btn span {
  font-size: 14px;
  color: #333;
}

.news_more_btn {
  text-align: center;
  margin-top: 60px;
}

.news_more {
  width: 114px;
  height: 32px;
}

.contact {
  position: relative;
  padding: 80px 0;
  background: #fff;
  height: 500px;
}

.contact_container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
}

.contact_left {
  position: relative;
  z-index: 999;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 692px;
  height: 206px;
  flex-shrink: 0;
  border-radius: 8px;
}

.contact_left_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.contact_info {
  margin-left: 40px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #3A3A3A;
  margin-bottom: 16px;
}

.contact_img {
  width: 774px;
  height: 376px;
  margin-left: -130px;
}

.contact_code {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 99;
}

.contact_code_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 16px;
}

.contact_code_qr_code {
  width: 150px;
  height: 150px;
}

.contact_title {
  position: absolute;
  top: 0;
  left: 0;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #222222;
}

.contact_info_box {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact_info_item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact_label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.contact_value {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.contact_right {
  flex: 1;
}

.map_container {
  width: 100%;
  height: 400px;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.map_placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%);
  position: relative;
}

.map_content {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 20px;
}

.map_header {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.map_logo {
  background: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.map_body {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map_location_pin {
  width: 20px;
  height: 30px;
  background: #007AFF;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  position: relative;
  margin-bottom: 40px;
}

.map_location_pin::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
}

.map_info_popup {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}

.popup_title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 8px;
}

.popup_address {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}

.popup_actions {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.popup_action {
  font-size: 12px;
  color: #007AFF;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f0f8ff;
}

.popup_action:hover {
  background: #e0f0ff;
}

.popup_close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 16px;
}

.map_controls {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.map_zoom_controls {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.zoom_btn {
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.zoom_btn:hover {
  background: #f5f5f5;
}

.map_footer {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.map_scale {
  font-size: 10px;
  color: #666;
}

.map_copyright {
  font-size: 10px;
  color: #999;
}

.bottom {
  background-color: #404c44;
  /* 深绿色背景 */
  padding: 80px 0;
  color: #fff;
  /* 文字颜色 */
}

.bottom_container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  /* 5列布局 */
  gap: 40px;
  /* 列间距 */
  padding: 0 20px;
}

.bottom_section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.bottom_title {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  margin-bottom: 16px;
}

.bottom_links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bottom_link {
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s ease;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
}

.bottom_link:hover {
  opacity: 0.8;
}

.bottom_contact_info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact_line {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact_label {
  flex-shrink: 0;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}

.contact_text {
  width: 572px;
  font-size: 16px;
  color: #fff;
  line-height: 1.8;
}

.qr_code_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr_code {
  width: 120px;
  height: 120px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.qr_code_placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
}

.qr_code_center_icon {
  width: 40px;
  height: 40px;
  background: #007AFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}

.qr_code_text {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.properties {
  padding: 80px 0;
  background: #fff;
}

.properties_container {
  width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.features_section {
  margin: 0 auto;
  margin-bottom: 80px;
}

.features_title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

.features_cards {
  display: flex;
  justify-content: space-around;
  margin-bottom: 30px;
}

.feature_card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.feature_icon {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_inheritance {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_safety {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_efficacy {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_nourishment {
  font-size: 40px;
  color: #007AFF;
}

.feature_icon_convenience {
  font-size: 40px;
  color: #007AFF;
}

.feature_label {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.feature_connector {
  width: 1px;
  height: 40px;
  background: #ddd;
  margin: 0 20px;
}

.safety_description {
  text-align: center;
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.honors_section {
  width: 1600px;
  margin-top: 80px;
}

.honors_title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 60px;
}

.honors_container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.honors_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
}

.nav_arrow {
  width: 40px;
  height: 40px;
  border: 2px dashed #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.nav_arrow:hover {
  background: #f5f5f5;
  border-color: #999;
}

.nav_arrow span {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.honors_cards {
  flex: 1;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.honor_card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.honor_image {
  width: 240px;
  height: 165px;
}

.honor_card:hover {
  transform: translateY(-8px);
}

.honor_seal {
  font-size: 40px;
  color: #007AFF;
  margin-bottom: 10px;
}

.honor_title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.honor_subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.honor_company {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.honor_card_highlighted {
  background: #f0f8ff;
  /* 浅蓝色背景 */
  border: 2px dashed #007AFF;
  /* 蓝色边框 */
}

.values {
  padding: 80px 0;
  background: #f5f5f5;
}

.values_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.values_title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #000;
  margin-bottom: 60px;
}

.value_sections {
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

.value_section {
  flex: 1;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value_section:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.value_icon_wrapper {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.value_icon {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
  border: 2px solid #007AFF;
}

.value_name {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 16px;
}

.value_description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  text-align: left;
}

.icon_shield {
  font-size: 40px;
  color: #007AFF;
  position: relative;
  z-index: 2;
}

.icon_stack {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stack_layer {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px dashed #007AFF;
  opacity: 0.3;
  animation: rotate 10s linear infinite;
}

.stack_layer_1 {
  animation-delay: -1s;
}

.stack_layer_2 {
  animation-delay: -2s;
}

.stack_layer_3 {
  animation-delay: -3s;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.stack_plus {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #007AFF;
  font-weight: bold;
  z-index: 2;
}

.icon_glow {
  position: absolute;
  top: -10px;
  left: -10px;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 122, 255, 0.2) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  pointer-events: none;
}

.value_section:hover .icon_glow {
  opacity: 1;
}

.icon_cube {
  position: relative;
  width: 60px;
  height: 60px;
  transform-style: preserve-3d;
  transform: rotateX(-30deg) rotateY(45deg);
  animation: cubeRotate 8s linear infinite;
}

@keyframes cubeRotate {
  0% {
    transform: rotateX(-30deg) rotateY(0deg);
  }

  100% {
    transform: rotateX(-30deg) rotateY(360deg);
  }
}

.cube_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  background: #007AFF;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(0, 122, 255, 0.5);
}

.cube_satellite {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #007AFF;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 122, 255, 0.3);
  animation: satelliteFloat 3s ease-in-out infinite;
}

.cube_satellite_1 {
  top: 0;
  left: 0;
  animation-delay: 0s;
}

.cube_satellite_2 {
  top: 0;
  right: 0;
  animation-delay: 0.5s;
}

.cube_satellite_3 {
  bottom: 0;
  left: 0;
  animation-delay: 1s;
}

.cube_satellite_4 {
  bottom: 0;
  right: 0;
  animation-delay: 1.5s;
}

@keyframes satelliteFloat {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-5px);
  }
}

.report {
  padding: 80px 0;
  background: #fff;
}

.report_container {
  width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  border-radius: 8px;
}

.breadcrumb {
  font-size: 14px;
  color: #666;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.breadcrumb_item {
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;
}

.breadcrumb_item:hover {}

.breadcrumb_separator {
  margin: 0 8px;
  color: #ccc;
}

.breadcrumb_active {
  font-weight: 600;
}

.article_header {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.article_title {
  margin-bottom: 16px;
  text-align: left;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
}

.article_date {
  text-align: left;

  font-size: 14px;
  color: #999;
  font-weight: 500;
}

.article_banner {
  position: relative;
  width: 100%;
  border-radius: 8px;
  margin-bottom: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.banner_image {
  width: 100%;
  object-fit: cover;
  /* height: 1000px; */
  object-fit: cover;
  transition: transform 0.3s ease;
}

.article_banner:hover .banner_image {
  transform: scale(1.05);
}

.banner_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.6) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 40px;
}

.banner_text {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  background: rgba(0, 122, 255, 0.8);
  padding: 12px 24px;
  border-radius: 6px;
  backdrop-filter: blur(10px);
}

.article_content {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 60px;
  padding: 0 20px;
}

.article_paragraph {
  margin-bottom: 24px;
  text-indent: 2em;
  text-align: justify;
}

.article_paragraph:last-child {
  margin-bottom: 0;
}

.article_navigation {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  padding: 40px 20px;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #D6D6D6;
}

.nav_prev,
.nav_next {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 20px;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.nav_prev:hover,
.nav_next:hover {
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.nav_label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.nav_title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
  line-height: 1.4;
}

.nav_title:hover {
  color: #D5EADA;
}

.good_detial {
  padding: 80px 0;
  background: #fff;
}

.good_detial_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.product_overview {
  display: flex;
  gap: 60px;
  margin-bottom: 80px;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
}

.product_gallery {
  flex: 1;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.thumbnail_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100px;
  flex-shrink: 0;
}

.thumbnail_item {
  width: 100px;
  height: 100px;
  border: 2px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.thumbnail_item:hover {
  border-color: #3D6451;
  transform: scale(1.05);
}

.thumbnail_item.active {
  border-color: #3D6451;
}

.thumbnail_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.thumbnail_item:hover .thumbnail_image {
  transform: scale(1.1);
}

.main_image_container {
  flex: 1;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  background: #f8f9fa;
  overflow: hidden;
}

.main_image {
  width: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.main_image_container:hover .main_image {
  transform: scale(1.02);
}

.product_info {
  flex: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
}

.product_title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 0;
  line-height: 1.3;
}

.product_description {
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 14px;
  color: #3A3A3A;
}

.product_specs {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.spec_item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 0;
}

.spec_label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  min-width: 80px;
}

.spec_value {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.inquiry_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px 30px;
  background: #4CAF50;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
  align-self: flex-start;
  margin-top: auto;
}

.inquiry_btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4);
  background: #45a049;
}

.inquiry_btn span {
  color: #fff;
}

.product_introduction {
  margin-top: 60px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.section_title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.section_title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #007AFF;
  border-radius: 2px;
}

.info_table {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 800px;
  margin: 0 auto;
}

.table_row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.table_row:last-child {
  border-bottom: none;
}

.table_row:hover {
  background: #f8f9fa;
}

.table_label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  min-width: 120px;
  padding-right: 30px;
  flex-shrink: 0;
  text-align: left;
}

.table_content {
  font-size: 16px;
  color: #666;
  text-align: left;
  flex: 1;
  line-height: 1.6;
}

.ingredients_efficacy {
  margin-top: 60px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.ingredients_section {
  margin-bottom: 40px;
}

.subsection_title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.subsection_title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: #007AFF;
  border-radius: 2px;
}

.ingredient_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  justify-content: center;
}

.ingredient_item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  text-align: center;
}

.ingredient_item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #007AFF;
}

.ingredient_name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  position: relative;
}

.ingredient_name::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #007AFF;
  border-radius: 1px;
}

.ingredient_desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}
</style>